import { Switch } from '@/utils/switch';
import { SxProps, Theme } from '@mui/material';

export const buttonCommonSX = ({
	variant,
	size,
	underline,
	color,
	disabled,
}: {
	variant?: string;
	size?: string;
	underline?: string;
	color?: string;
	disabled?: boolean;
}): SxProps<Theme> => ({
	...Switch(variant)
		.case('text', () => ({
			fontSize: Switch(size)
				.case('small', () => '13px')
				.case('default', () => '14px')
				.case('medium', () => '15px')
				.case('large', () => '16px')
				.defaultTo(() => '15px'),
			color: Switch(color)
				.case('default', () => '#2C2C2C')
				.defaultTo(() => 'primary.main'),
			...Switch(underline)
				.case('hover', () => ({
					textDecoration: 'none',
					'&:hover': {
						textDecoration: 'underline',
					},
				}))
				.case('always', () => ({
					textDecoration: 'underline',
				}))
				.defaultTo(() => ({
					textDecoration: 'none',
					'&:hover': {
						color: 'primary.dark',
					},
				})),

			...(disabled
				? {
						backgroundColor: 'transparent !important',
						color: 'primary.main !important',
						cursor: 'not-allowed !important',
						'&:hover': {
							backgroundColor: 'transparent !important',
							color: 'primary.main !important',
						},
				  }
				: {}),
		}))
		.defaultTo(() => ({
			padding: Switch(size)
				.case('small', () => '8px 4px')
				.defaultTo(() => '12px 24px'),
			borderRadius: '50px',
			fontSize: Switch(size)
				.case('small', () => '13px')
				.defaultTo(() => '15px'),
			fontWeight: 'bold',
		})),
	...{
		...Switch(variant)
			.case('outlined', () => ({
				background: 'transparent',
				border: '1px solid',
				borderColor: 'primary.main',
				color: 'primary.main',
				'&.Mui-disabled': {
					borderColor: 'gray',
					color: 'gray',
					backgroundColor: 'transparent',
					cursor: 'not-allowed',
				},
			}))
			.case('unfocused', () => ({
				background: '#F1F1F1',
				color: '#333',
				'&:hover': {
					background: '#707070',
					color: '#FFF',
				},
			}))
			.defaultTo(() => ({
				'&.Mui-disabled': {
					backgroundColor: 'gray',
					color: '#ffffff',
					opacity: 0.5,
				},
			})),
	},
});
